import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { parseHttpErrorBody } from '../../shared/forms/parse-http-error-body';
import 'rxjs/Rx';
import {Observable} from 'rxjs/Observable';

import {GlobalVariable} from '../../global';
import {MonetaryArea} from './monetary-area.model';
import {
  RequestParameters
} from '../../shared/models/request-parameters/parameter.model';

@Injectable()

export class MonetaryAreaService {

  constructor(private http: HttpClient) {
  }

  getMonetaryAreas (parameters: RequestParameters = new RequestParameters()) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/monetary-areas', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
      (error: HttpErrorResponse) => {
        return Observable.throw({
          code: error.status,
          content: JSON.parse(error.error).message,
          body: parseHttpErrorBody(error)
        });
      }
    );

  }

  postMonetaryArea (monetaryArea: MonetaryArea) {

    const body = Object.assign({}, monetaryArea);
    delete body.reference;

    return this.http.post(GlobalVariable.BASE_API_URL + '/monetary-areas', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  putMonetaryArea (monetaryArea: MonetaryArea) {

    const body = Object.assign({}, monetaryArea);
    delete body.reference;

    return this.http.put(GlobalVariable.BASE_API_URL + '/monetary-area/' + monetaryArea.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  deleteMonetaryArea (monetaryArea: MonetaryArea) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/monetary-area/' + monetaryArea.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/parameters/monetary-areas/monetary-area.service.ts